import { Component } from '@angular/core';
import { ScheduleCardData } from 'src/app/common-components/cards/schedule-card/schedule-card.types';

@Component({
  selector: 'app-schedule-card-playground',
  templateUrl: './schedule-card-playground.component.html',
  styleUrls: ['./schedule-card-playground.component.scss'],
})
export class ScheduleCardPlaygroundComponent {
  /** Figma Munily UI Kit — Schedule card `6512:33797` */
  readonly sampleData: ScheduleCardData = {
    dayLabel: 'Sábado',
    slots: [
      { fromLabel: 'Desde: 00:00 mm', toLabel: 'Hasta: 00:00 mm' },
      { fromLabel: 'Desde: 14:00 mm', toLabel: 'Hasta: 18:00 mm' },
    ],
  };

  readonly emptyData: ScheduleCardData = {
    dayLabel: 'Domingo',
    slots: [],
  };
}
